import { isString } from 'lodash';
import API from 'services/API';

export default function makeAppointment(data) {
  return API.request({
    method: 'POST',
    url: '/appointment/book',
    data: data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    mapper: function (data) {
      if (isString(data) || data.error) {
        return data;
      }

      const appointment = data && data.appointment ? data.appointment : {};
      const taxAuthority = data && data.taxAuthority ? data.taxAuthority : {};
      return {
        bookId: appointment ? appointment.appointmentNumber : null,
        error: null,
        pincode: appointment.pin,
        window: appointment.window,
        serviceWay: taxAuthority.way,
      };
    },
  });
}
